module.exports = "/layout/app/images/bg-section-veello-theme-insights-after.2f8ce7be.svg";